export interface Article {
  id: number;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  image: string;
  author: string;
  date: string;
  views: number;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export const articles: Article[] = [
  {
    id: 1,
    slug: 'dingliu-yanyuan-taofang-neimu',
    title: '某顶流男演员被曝税务问题，涉及金额高达数千万，工作室紧急回应引热议',
    excerpt: '近日，有知情人士向本平台独家爆料，某当红顶流男演员因税务问题被相关部门约谈，涉及金额或达数千万。该演员此前一直以正能量形象示人，此次爆料一出立即引发全网热议，粉丝纷纷要求工作室给出正面回应。',
    content: `<p>近日，有知情人士向本平台独家爆料，某当红顶流男演员因税务问题被相关部门约谈，涉及金额或达数千万。</p>
<p>据爆料人透露，该演员在过去三年间通过多家关联公司进行复杂的资金运作，涉嫌利用"阴阳合同"方式逃避个人所得税。爆料称相关部门已经掌握充分证据，目前案件正在进一步调查中。</p>
<p>消息一出，该演员的工作室火速发布声明，称"相关信息纯属造谣，已委托律师进行取证，将依法追究造谣者的法律责任"。然而这一回应并未平息舆论，反而引发了更多网友的质疑。</p>
<p>有税务专业人士分析指出，近年来娱乐圈税务整顿力度持续加大，已有多位知名艺人因税务问题受到处罚。如果此次爆料属实，该演员可能面临巨额罚款甚至刑事责任。</p>
<p>值得注意的是，该演员近期有多部待播剧集和代言合约，若税务问题坐实，将对其演艺事业造成毁灭性打击。目前多家品牌方已开始密切关注事态发展。</p>
<p>截至发稿时，相关部门尚未对此事作出正式回应。本平台将持续关注事件进展。</p>`,
    category: 'mingxing',
    categoryName: '明星爆料',
    image: 'https://readdy.ai/api/search-image?query=Breaking%20news%20background%20with%20dramatic%20red%20lighting%20and%20spotlight%20effect%2C%20dark%20cinematic%20atmosphere%2C%20sensational%20news%20style%2C%20dramatic%20shadows%2C%20professional%20news%20photography%20aesthetic&width=800&height=450&seq=article-01&orientation=landscape',
    author: '51黑料编辑部',
    date: '2026-08-05',
    views: 128500,
    tags: ['明星', '税务', '顶流', '爆料'],
    isHot: true,
    isNew: true,
  },
  {
    id: 2,
    slug: 'wanghong-zhibo-fanche-jiahuo',
    title: '知名带货网红直播翻车！被实锤售卖假货，消费者集体维权索赔超百万',
    excerpt: '拥有千万粉丝的带货网红"XX姐"近日被消费者实锤直播间售卖假冒名牌化妆品，已有超过500名消费者联合维权，索赔金额超过百万。该网红此前一直以"正品保障"为卖点，此次翻车让粉丝大失所望。',
    content: `<p>拥有千万粉丝的带货网红"XX姐"近日遭遇了职业生涯最大的一次危机。多名消费者在社交平台晒出检测报告，实锤其直播间售卖的某国际知名品牌化妆品为假冒产品。</p>
<p>据维权群内消费者反映，他们购买的产品外包装与正品几乎一致，但使用后出现过敏、红肿等不良反应。经专业机构检测，产品成分与正品完全不符，确认为假冒伪劣商品。</p>
<p>目前已有超过500名消费者联合起来，组建了维权群，集体向消费者协会和市场监督管理部门投诉举报。据初步统计，涉及金额已超过百万元。</p>
<p>面对舆论压力，该网红在直播中回应称自己也是"受害者"，表示是被供应商欺骗，承诺将配合调查并承担相应责任。然而这一说辞并未获得消费者认可，许多老粉丝表示"再也不会相信她"。</p>
<p>业内人士指出，直播带货行业鱼龙混杂，部分主播为了高额佣金不惜售卖假冒伪劣产品。此次事件再次敲响了行业警钟，呼吁监管部门加强对直播带货的规范和监督。</p>`,
    category: 'wanghong',
    categoryName: '网红黑料',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20showing%20live%20streaming%20shopping%20interface%20with%20dramatic%20red%20warning%20overlay%2C%20dark%20moody%20background%2C%20consumer%20rights%20theme%2C%20professional%20newsroom%20style%20photography&width=800&height=450&seq=article-02&orientation=landscape',
    author: '51黑料编辑部',
    date: '2026-08-04',
    views: 96300,
    tags: ['网红', '直播带货', '假货', '维权'],
    isHot: true,
    isNew: true,
  },
  {
    id: 3,
    slug: 'zongyi-jiemu-heimu-neiding',
    title: '热门选秀节目被曝严重黑幕！选手爆料：晋级名单早已内定，投票全是假的',
    excerpt: '一档正在热播的选秀节目被参赛选手实名爆料，称节目组在赛前就已内定晋级名单，观众投票只是"走过场"。该选手还提供了与节目组工作人员的聊天记录作为证据，引发轩然大波。',
    content: `<p>近日，一档正在热播的选秀节目被淘汰选手实名爆料，揭露了节目背后令人震惊的内幕操作。</p>
<p>该选手在社交平台发布长文，称自己在参赛过程中多次遭遇不公平对待。据其透露，节目组在每轮比赛前就已经确定了晋级名单，所谓的"观众投票"和"导师打分"完全是按照剧本执行的。</p>
<p>该选手还晒出了与节目组工作人员的微信聊天记录作为证据。截图显示，工作人员明确告知"这轮你可能要走"，并暗示"配合节目效果会有补偿"。爆料中还提到，有选手通过"特殊关系"获得了额外的镜头和宣传资源。</p>
<p>爆料发布后，大量网友涌入节目官方账号评论区表达愤怒，话题迅速登上热搜榜首。多位曾被淘汰的选手也纷纷发声支持，称自己也曾遭遇类似情况。</p>
<p>节目组随后发布声明否认所有指控，称"节目始终坚持公平公正原则，所有投票数据均可查证"。但有业内人士分析认为，选秀节目的黑幕操作在业内并非个例，此次事件可能只是冰山一角。</p>`,
    category: 'yulequan',
    categoryName: '娱乐圈',
    image: 'https://readdy.ai/api/search-image?query=Talent%20show%20stage%20with%20dramatic%20spotlights%20and%20dark%20silhouette%2C%20contest%20rigging%20theme%2C%20mysterious%20cinematic%20atmosphere%2C%20professional%20entertainment%20photography&width=800&height=450&seq=article-03&orientation=landscape',
    author: '51黑料编辑部',
    date: '2026-08-03',
    views: 157200,
    tags: ['选秀', '黑幕', '综艺', '爆料'],
    isHot: true,
    isNew: false,
  },
  {
    id: 4,
    slug: 'nvyanyuan-qian-guize-shangwei',
    title: '圈内人士爆料：某女演员靠潜规则上位，与多位导演有不正当关系',
    excerpt: '一位自称在娱乐圈工作多年的幕后人员近日向媒体爆料，详细揭露了某当红女演员通过不正当手段获取资源的全过程。据称该女演员与多位知名导演保持暧昧关系，借此获得了多部大制作女主角的机会。',
    content: `<p>一位自称在娱乐圈工作超过十年的幕后工作人员，近日通过匿名方式向多家媒体提供了大量关于某当红女演员的爆料材料。</p>
<p>据该人士透露，这位女演员在出道初期资源平平，但在与某知名导演建立"特殊关系"后，迅速获得了多部大制作影视剧的女主角邀约。此后，她陆续与多位导演和制片人传出绯闻，每一次"合作"都带来了更多优质资源。</p>
<p>爆料中详细描述了该女演员如何利用饭局、私人聚会等场合与圈内大咖建立关系，以及她背后团队如何运作这些关系来获取资源。该人士表示，在娱乐圈这种现象并不罕见，"只是很少有人愿意公开说出来"。</p>
<p>截至目前，被爆料的女演员及其团队尚未对此事作出回应。但有细心的网友发现，该女演员的社交账号评论区已被设置为"仅粉丝可评论"。</p>
<p>业内人士分析认为，娱乐圈的潜规则问题由来已久，要彻底解决需要整个行业的共同努力和监管部门的有效介入。</p>`,
    category: 'yulequan',
    categoryName: '娱乐圈',
    image: 'https://readdy.ai/api/search-image?query=Dark%20backstage%20of%20a%20theater%20with%20dramatic%20red%20curtains%20and%20mysterious%20atmosphere%2C%20Hollywood%20scandal%20theme%2C%20cinematic%20film%20noir%20style%20photography%2C%20shadows%20and%20spotlights&width=800&height=450&seq=article-04&orientation=landscape',
    author: '51黑料编辑部',
    date: '2026-08-02',
    views: 203400,
    tags: ['女演员', '潜规则', '导演', '娱乐圈'],
    isHot: true,
    isNew: false,
  },
  {
    id: 5,
    slug: 'daiyun-fengbo-dingji-nvxing',
    title: '代孕风波再起！多位女明星被传海外代孕，知情人称已掌握关键证据',
    excerpt: '娱乐圈代孕风波持续发酵！继此前多位明星被卷入代孕争议后，又有知情人向本平台爆料，称有多位一线女明星通过海外机构进行代孕，目前已掌握包括医院记录在内的多项关键证据。',
    content: `<p>娱乐圈代孕风波近日再度成为舆论焦点。据知情人向本平台独家爆料，有多位国内一线女明星涉嫌通过海外代孕机构生育子女。</p>
<p>据爆料人透露，这些女明星通常选择在美国加州或东南亚国家的医疗机构进行代孕操作，整个过程高度保密。爆料人声称已掌握了包括医院就诊记录、付款凭证在内的多项关键证据。</p>
<p>爆料中指出，这些女明星选择代孕的原因多种多样，有的是为了保持身材不影响事业，有的是因为年龄偏大担心生育风险，还有的则是为了隐瞒真实的感情状况。</p>
<p>值得注意的是，代孕在中国内地属于违法行为。根据《人类辅助生殖技术管理办法》，医疗机构和医务人员不得实施任何形式的代孕技术。若爆料属实，涉事女明星可能面临法律风险。</p>
<p>截至目前，被点名的女明星均未对此事作出回应。有法律专家表示，如果证据确凿，相关当事人可能面临行政处罚，严重者甚至可能被追究刑事责任。</p>`,
    category: 'mingxing',
    categoryName: '明星爆料',
    image: 'https://readdy.ai/api/search-image?query=Silhouette%20of%20a%20woman%20behind%20frosted%20glass%20with%20dramatic%20lighting%2C%20mystery%20and%20controversy%20theme%2C%20dark%20elegant%20atmosphere%2C%20cinematic%20photography%20style&width=800&height=450&seq=article-05&orientation=landscape',
    author: '51黑料编辑部',
    date: '2026-08-01',
    views: 185600,
    tags: ['代孕', '女明星', '海外', '法律'],
    isHot: false,
    isNew: false,
  },
  {
    id: 6,
    slug: 'zhibo-pingtai-shuju-zaojia',
    title: '直播平台数据造假产业链曝光：千万观看量只需几百元，刷量工作室日入过万',
    excerpt: '记者暗访发现，直播平台数据造假已形成完整产业链。从直播间人气、点赞数到商品销量，几乎所有数据都可以通过刷量服务进行造假。一家刷量工作室负责人声称，千万观看量只需几百元成本。',
    content: `<p>近日，有记者通过暗访调查，揭露了直播平台数据造假的惊人内幕。从直播间人气到商品销量，几乎所有可见的数据指标都可以通过专业刷量服务进行造假。</p>
<p>记者以商家身份联系了多家刷量工作室，发现价格出奇低廉。据一家工作室负责人介绍，1000万直播间观看量只需500元左右，1万条高质量弹幕评论约200元，而模拟真实用户下单的"精刷"服务也仅需按单计费。</p>
<p>更令人震惊的是，这些刷量工作室已形成完整的产业链。上游有专门开发刷量软件的技術团队，中游有负责接单和分配任务的运营团队，下游则是遍布全国各地的"刷手"。据业内人士估算，一家中等规模的刷量工作室日收入可过万元。</p>
<p>平台方对刷量行为的打击力度正在加大。多家直播平台表示已升级反作弊系统，将对刷量行为进行严厉处罚。但刷量工作室也在不断升级技术手段，形成了"道高一尺魔高一丈"的博弈局面。</p>`,
    category: 'shehui',
    categoryName: '社会热点',
    image: 'https://readdy.ai/api/search-image?query=Rows%20of%20smartphones%20on%20a%20desk%20with%20automated%20scripts%20running%2C%20dark%20room%20with%20screen%20glow%2C%20cyber%20crime%20investigation%20theme%2C%20professional%20documentary%20photography&width=800&height=450&seq=article-06&orientation=landscape',
    author: '51黑料编辑部',
    date: '2026-07-31',
    views: 89200,
    tags: ['直播', '数据造假', '刷量', '产业链'],
    isHot: false,
    isNew: false,
  },
  {
    id: 7,
    slug: 'gechang-jiachang-baoguang-zhibo',
    title: '知名歌手演唱会假唱被现场抓包！对口型失误引全场哗然，粉丝要求退票',
    excerpt: '某知名歌手在近日的巡回演唱会上被现场观众抓包假唱。据目击者描述，歌手在演唱过程中出现对口型失误，伴奏突然中断后歌声仍在继续，现场顿时一片哗然。大量粉丝涌入社交平台要求退票赔偿。',
    content: `<p>知名歌手假唱事件在社交平台引发巨大争议。据多名现场观众描述，在某城市举办的巡回演唱会上，该歌手在演唱代表作时出现了明显的对口型失误。</p>
<p>目击者称，当时伴奏突然出现短暂中断，但"歌声"却继续了约2秒钟才停止。现场观众瞬间哗然，不少粉丝当场高喊"假唱退票"。有观众用手机记录下了这一尴尬瞬间，视频上传后迅速获得数百万播放量。</p>
<p>事件发酵后，大量购票粉丝涌入票务平台和歌手社交账号评论区，要求退票赔偿。有消费者表示，演唱会门票价格高达上千元，假唱行为严重侵害了消费者权益。</p>
<p>该歌手团队目前尚未对此事作出正式回应。但有业内人士分析指出，歌手在大型演唱会上使用"垫音"是业内常见做法，但完全假唱则突破了行业底线。</p>
<p>文化和旅游部门相关规定明确要求，营业性演出不得以假唱、假演奏欺骗观众。若假唱行为被确认，主办方和演出者可能面临行政处罚。</p>`,
    category: 'mingxing',
    categoryName: '明星爆料',
    image: 'https://readdy.ai/api/search-image?query=Concert%20stage%20with%20bright%20spotlights%20and%20empty%20microphone%20stand%2C%20dramatic%20red%20and%20blue%20stage%20lighting%2C%20controversy%20theme%2C%20professional%20concert%20photography&width=800&height=450&seq=article-07&orientation=landscape',
    author: '51黑料编辑部',
    date: '2026-07-30',
    views: 214800,
    tags: ['假唱', '演唱会', '歌手', '退票'],
    isHot: true,
    isNew: false,
  },
  {
    id: 8,
    slug: 'wanghong-beihou-MCN-bouxue',
    title: 'MCN机构被曝疯狂压榨签约网红！分成比例仅1:9，不听话就雪藏封杀',
    excerpt: '多位签约网红联合发声，揭露MCN机构的霸王条款和压榨内幕。据爆料，部分MCN机构与网红的分成比例低至1:9，且合同中包含大量不平等条款，一旦网红不服从安排就会被雪藏封杀。',
    content: `<p>近日，多位签约网红联合发声，揭露了MCN（多频道网络）机构背后的种种霸王条款和压榨内幕，引发了行业内外广泛关注。</p>
<p>据一位拥有百万粉丝的网红透露，其与MCN机构签订的分成比例仅为1:9，即她每赚10元只能分到1元。合同中还包含了大量不平等条款：机构有权单方面决定内容方向、商业合作和账号运营，网红几乎没有自主权。</p>
<p>更令人触目惊心的是所谓的"雪藏条款"。多位网红表示，一旦不服从机构安排或提出合理诉求，就会被机构故意减少推广资源、限制账号曝光，甚至直接冻结账号。有的网红因此从百万粉丝跌落至无人问津。</p>
<p>法律专家指出，部分MCN合同中的条款可能涉嫌违反《民法典》关于公平原则的规定。但由于网红行业属于新兴领域，相关法律法规仍不完善，维权难度较大。</p>
<p>截至目前，已有超过200名签约网红加入了维权联盟，希望通过集体行动引起监管部门的重视，推动行业规范制定。</p>`,
    category: 'wanghong',
    categoryName: '网红黑料',
    image: 'https://readdy.ai/api/search-image?query=Dark%20office%20with%20contracts%20and%20chains%20metaphor%2C%20exploitation%20theme%2C%20dramatic%20lighting%20with%20shadows%2C%20corporate%20corruption%20concept%2C%20professional%20documentary%20photography&width=800&height=450&seq=article-08&orientation=landscape',
    author: '51黑料编辑部',
    date: '2026-07-29',
    views: 76800,
    tags: ['MCN', '网红', '霸王条款', '维权'],
    isHot: false,
    isNew: false,
  },
  {
    id: 9,
    slug: 'toushuiloushui-yulequan-zhengdun',
    title: '娱乐圈税务大整顿再度升级！多名艺人被约谈，最高或面临刑事处罚',
    excerpt: '据悉，税务部门近期对娱乐圈展开了新一轮税务稽查行动，已有多名艺人被约谈。此次稽查范围涵盖个人所得、工作室经营、投资分红等多个方面，涉嫌严重逃税的艺人最高可能面临刑事处罚。',
    content: `<p>据可靠消息，税务部门近期对娱乐圈展开了新一轮大规模税务稽查行动，力度之大前所未有。已有多位知名艺人、导演、制片人被税务部门约谈。</p>
<p>据悉，此次稽查范围涵盖个人劳务所得、工作室经营收入、影视投资分红、广告代言费用等多个方面。税务部门运用大数据手段，对艺人的收入流水和纳税记录进行了交叉比对，发现了大量可疑线索。</p>
<p>一位接近税务部门的消息人士透露，此次行动是此前娱乐圈税务整顿的延续和升级。部分艺人通过各种手段隐匿收入、虚报支出，涉案金额惊人。根据相关法律规定，涉嫌严重逃税的艺人最高可能面临3年以上7年以下有期徒刑。</p>
<p>多位娱乐圈人士对此表示担忧，认为此次税务整顿可能引发行业"地震"，一些长期依赖灰色操作的艺人和公司将面临生存危机。但也有观点认为，这是行业走向规范化的必经之路。</p>`,
    category: 'shehui',
    categoryName: '社会热点',
    image: 'https://readdy.ai/api/search-image?query=Government%20building%20silhouette%20with%20tax%20documents%20and%20red%20stamp%2C%20official%20investigation%20theme%2C%20serious%20atmosphere%2C%20professional%20news%20photography%20style&width=800&height=450&seq=article-09&orientation=landscape',
    author: '51黑料编辑部',
    date: '2026-07-28',
    views: 134500,
    tags: ['税务', '稽查', '艺人', '法律'],
    isHot: false,
    isNew: false,
  },
  {
    id: 10,
    slug: 'zongyi-jianu-neimu-baoguang',
    title: '综艺节目嘉宾片酬内幕曝光：一线艺人单期报价超千万，鲜肉靠流量漫天要价',
    excerpt: '一份疑似综艺节目制作内部文件流出，曝光了多位艺人参加综艺节目的真实片酬。一线顶级艺人单期报价超过千万元，而一些仅有流量的年轻艺人同样要价惊人，引发业内外对综艺片酬虚高的讨论。',
    content: `<p>一份疑似来自某大型综艺节目制作团队的内部文件日前在网络上流传，曝光了多位艺人参加综艺节目的真实片酬报价。</p>
<p>根据文件显示，一线顶级艺人的单期报价普遍在800万至1500万元之间，其中以一位影视歌三栖巨星的单期报价最高，达到惊人的1800万元。按一季12期计算，其单季收入高达2.16亿元。</p>
<p>令人意外的是，一些仅有流量但缺乏作品的年轻艺人同样要价不菲。文件显示，多位选秀出身的偶像艺人单期报价在300万至500万元之间，部分热门流量明星甚至开出了700万元的高价。</p>
<p>业内资深制作人表示，综艺片酬的虚高已经严重挤压了节目的制作经费，导致节目质量下降。一些节目为了请到大牌艺人，不得不在制作上偷工减料，形成了恶性循环。</p>
<p>广电总局此前已多次发文要求合理控制艺人片酬，但从实际情况来看，执行效果并不理想。业内人士呼吁，需要建立更加透明和规范的片酬体系。</p>`,
    category: 'yulequan',
    categoryName: '娱乐圈',
    image: 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20bright%20lights%20and%20money%20flying%20metaphor%2C%20entertainment%20industry%20excess%20theme%2C%20dramatic%20lighting%2C%20professional%20broadcast%20photography&width=800&height=450&seq=article-10&orientation=landscape',
    author: '51黑料编辑部',
    date: '2026-07-27',
    views: 98700,
    tags: ['综艺', '片酬', '一线艺人', '流量'],
    isHot: false,
    isNew: false,
  },
  {
    id: 11,
    slug: 'shipinhao-neirong-dibanxian',
    title: '短视频平台内容底线持续刷新！为博眼球无所不用其极，监管部门重拳出击',
    excerpt: '近期多个短视频平台出现大量低俗、危险甚至违法的挑战内容，从"吃播浪费"到"极限挑战"，不断刷新公众认知底线。国家网信办已对多家平台进行约谈，要求立即清理违规内容。',
    content: `<p>短视频平台的内容乱象近期再度引发社会广泛关注。从"大胃王吃播浪费"到"高空极限自拍"，从"恶搞路人"到"未成年人危险模仿"，各种突破底线的挑战内容层出不穷。</p>
<p>据调查，这些极端内容背后往往有着清晰的商业逻辑。越是争议性大、刺激性强的视频，越容易获得平台的算法推荐，从而带来巨大的流量和收益。一位前短视频创作者透露，一条争议视频的收入可能是普通视频的数十倍。</p>
<p>在巨大利益驱动下，一些创作者不惜铤而走险。近期发生的多起"极限挑战"事故已造成人员伤亡，而"未成年人模仿危险行为"导致的事故更是引发了全社会对平台责任的追问。</p>
<p>国家网信办已对多家短视频平台进行约谈，要求立即清理违规内容，建立更加严格的内容审核机制。部分平台已下架了大量违规内容，封禁了一批违规账号。</p>
<p>但对于平台而言，如何在内容安全和用户活跃度之间找到平衡，仍然是一个巨大的挑战。</p>`,
    category: 'shehui',
    categoryName: '社会热点',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20displaying%20warning%20signs%20and%20danger%20symbols%2C%20social%20media%20danger%20theme%2C%20dramatic%20red%20warning%20lighting%2C%20professional%20technology%20photography&width=800&height=450&seq=article-11&orientation=landscape',
    author: '51黑料编辑部',
    date: '2026-07-26',
    views: 112300,
    tags: ['短视频', '内容底线', '监管', '安全'],
    isHot: false,
    isNew: false,
  },
  {
    id: 12,
    slug: 'mingxing-hunbian-chugui-baoguang',
    title: '模范夫妻人设崩塌！某明星夫妇被曝双双出轨，维持表面婚姻只为商业利益',
    excerpt: '一直以模范夫妻形象示人的某明星夫妇被圈内人士爆料，称两人早已各自出轨多年，维持婚姻关系纯粹是为了商业利益和品牌代言。据称双方各自有固定的婚外伴侣，在圈内已是公开的秘密。',
    content: `<p>又一对明星夫妻的"模范"人设崩塌了。据多位圈内人士向本平台爆料，某一直以恩爱形象示人的明星夫妇实际上早已貌合神离，双方各自拥有固定的婚外伴侣。</p>
<p>据知情人士透露，这对明星夫妇的婚姻早在五年前就已经名存实亡。但由于两人共同持有多个商业品牌和代言合约，一旦离婚将面临巨额违约金赔偿。因此双方达成"默契"，维持表面的婚姻关系。</p>
<p>爆料中详细描述了两人各自出轨的细节：男方与一位年轻女演员保持着长期关系，而女方则与一位圈外商人交往密切。两人在公开场合仍然配合默契地表演恩爱，私下却几乎不交流。</p>
<p>有趣的是，就在上个月，这对夫妻还在社交媒体上发布了"甜蜜"的结婚纪念日合照，获得了数百万点赞和祝福。如今看来，这一切不过是精心策划的公关表演。</p>
<p>截至目前，这对明星夫妇尚未对此事作出回应。但其代言的多个品牌已经紧急启动了舆情监控，随时准备应对可能的公关危机。</p>`,
    category: 'mingxing',
    categoryName: '明星爆料',
    image: 'https://readdy.ai/api/search-image?query=Broken%20wedding%20rings%20on%20a%20dark%20surface%20with%20dramatic%20lighting%2C%20celebrity%20marriage%20scandal%20theme%2C%20elegant%20but%20dark%20atmosphere%2C%20professional%20jewelry%20photography%20style&width=800&height=450&seq=article-12&orientation=landscape',
    author: '51黑料编辑部',
    date: '2026-07-25',
    views: 246100,
    tags: ['明星', '出轨', '人设', '婚姻'],
    isHot: true,
    isNew: false,
  },
  {
    id: 13,
    slug: 'AI-huannian-yulequan-yingxiang',
    title: 'AI换脸技术入侵娱乐圈！多位女星遭恶意换脸制作不雅视频，警方介入调查',
    excerpt: '利用AI换脸技术制作明星不雅视频的黑色产业链正在快速蔓延。据报道，目前已有多位知名女星成为受害者，相关视频在暗网和境外平台大肆传播。警方已成立专案组对此进行调查。',
    content: `<p>随着AI技术的快速发展，利用深度伪造（Deepfake）技术制作明星虚假不雅视频的黑色产业链正在快速蔓延，引发了娱乐圈和社会的广泛担忧。</p>
<p>据调查，目前已有多位国内知名女星成为深度伪造技术的受害者。不法分子利用AI换脸技术，将这些女星的面部替换到不雅视频中，制作出逼真度极高的虚假内容。相关视频在暗网和境外社交平台上大肆传播，有的甚至被用于敲诈勒索。</p>
<p>一位受害者团队的工作人员向本平台透露，虽然明知是伪造内容，但这些视频的传播仍然对艺人的形象和心理健康造成了严重伤害。有女星因此患上了严重的焦虑症，不得不暂停所有工作。</p>
<p>警方对此高度重视，已成立专案组展开调查。根据相关法律规定，制作和传播深度伪造淫秽内容可能构成制作、传播淫秽物品罪，同时还可能涉及侵犯肖像权和名誉权等民事侵权责任。</p>
<p>技术专家呼吁，应在技术发展的同时加强法律法规建设和公众教育，从源头遏制深度伪造技术的滥用。</p>`,
    category: 'shehui',
    categoryName: '社会热点',
    image: 'https://readdy.ai/api/search-image?query=Digital%20face%20being%20scanned%20with%20AI%20grid%20overlay%2C%20deepfake%20technology%20theme%2C%20dystopian%20digital%20atmosphere%2C%20cybersecurity%20concept%2C%20professional%20tech%20photography&width=800&height=450&seq=article-13&orientation=landscape',
    author: '51黑料编辑部',
    date: '2026-07-24',
    views: 178900,
    tags: ['AI换脸', '女星', '不雅视频', '警方'],
    isHot: true,
    isNew: false,
  },
  {
    id: 14,
    slug: 'wangluo-zhuboxintai-bengkuai',
    title: '网红主播心理健康危机：为流量日播12小时，多人确诊重度抑郁',
    excerpt: '光鲜亮丽的网红主播背后，隐藏着令人担忧的心理健康危机。多位网红近日勇敢分享了自己的心理健康问题，揭示了高强度直播带来的焦虑、抑郁和 burnout。有主播表示每天直播12小时，几乎没有私人生活。',
    content: `<p>在光鲜亮丽的直播间背后，越来越多的网红主播正在经历严重的心理健康危机。近期，多位拥有百万粉丝的主播勇敢公开了自己的心理健康诊断结果，引发了社会对这一群体心理状态的关注。</p>
<p>一位游戏主播在视频中泪流满面地分享了自己的经历：为了维持热度，她每天直播时间超过12小时，几乎没有私人生活和社交。长期的高压状态导致她患上了重度抑郁症和焦虑症，曾多次产生轻生念头。</p>
<p>另一位带货主播透露，自己每天要面对数万条评论，其中有大量恶意攻击和人身侮辱。"一开始还能不在意，但时间久了真的会崩溃。每天晚上躺在床上，脑子里全是那些骂我的话。"</p>
<p>心理学专家指出，网红主播面临的压力来源是多方面的：流量焦虑、网络暴力、工作与生活失衡、收入不稳定等都是重要的压力源。但由于工作性质特殊，他们往往难以获得及时有效的心理支持。</p>
<p>多个MCN机构已开始为主播提供心理健康服务，但业内人士认为，要根本解决问题，还需要整个行业生态的良性转变。</p>`,
    category: 'wanghong',
    categoryName: '网红黑料',
    image: 'https://readdy.ai/api/search-image?query=Person%20sitting%20alone%20in%20a%20dark%20room%20lit%20only%20by%20a%20computer%20screen%2C%20mental%20health%20struggle%20theme%2C%20loneliness%20and%20burnout%2C%20emotional%20documentary%20photography&width=800&height=450&seq=article-14&orientation=landscape',
    author: '51黑料编辑部',
    date: '2026-07-23',
    views: 65400,
    tags: ['网红', '心理健康', '抑郁', '直播'],
    isHot: false,
    isNew: false,
  },
  {
    id: 15,
    slug: 'pianqu-tuanshan-zuixin-baoguang',
    title: '某慈善基金会善款去向成谜！负责人被曝用善款购买豪车豪宅，警方立案侦查',
    excerpt: '又一起慈善丑闻曝光！某知名慈善基金会被内部员工实名举报，称基金会负责人存在严重贪污行为，将大笔善款挪用于个人消费。据举报材料显示，包括豪车、豪宅在内的个人消费均来自善款账户。',
    content: `<p>慈善领域再曝重大丑闻。某知名慈善基金会被内部员工实名举报，称基金会主要负责人存在严重的贪污善款行为，目前警方已正式立案侦查。</p>
<p>根据举报材料，该基金会负责人利用职务之便，通过虚构项目、虚报支出等手段，在三年间累计挪用善款超过2000万元。这些款项被用于购买豪车、豪宅以及在境外的奢侈消费。</p>
<p>举报人提供的银行流水显示，善款账户有大量可疑的资金转出记录，收款方多为与该负责人有关联的个人账户和空壳公司。此外，举报材料中还包含了负责人在社交媒体上炫耀豪车豪宅的截图。</p>
<p>该基金会此前一直以"透明公益"为宣传口号，曾获得多个行业奖项，多位明星曾为其站台宣传。丑闻曝光后，多位合作明星紧急发布声明，与基金会切割关系。</p>
<p>民政部门已介入调查，表示将对慈善组织的资金使用进行全面审计，严厉打击慈善领域的违法违规行为。本平台将持续关注案件进展。</p>`,
    category: 'shehui',
    categoryName: '社会热点',
    image: 'https://readdy.ai/api/search-image?query=Charity%20donation%20box%20with%20chains%20and%20lock%2C%20corruption%20scandal%20theme%2C%20dark%20moody%20atmosphere%2C%20financial%20crime%20concept%2C%20professional%20investigative%20photography&width=800&height=450&seq=article-15&orientation=landscape',
    author: '51黑料编辑部',
    date: '2026-07-22',
    views: 89700,
    tags: ['慈善', '贪污', '善款', '举报'],
    isHot: false,
    isNew: false,
  },
  {
    id: 16,
    slug: 'yinren-gongzuoshi-neihong',
    title: '知名艺人工作室爆发严重内讧！经纪人携核心团队集体出走，背后真相令人震惊',
    excerpt: '某知名艺人的工作室近日爆发严重内讧，跟随多年的经纪人和核心团队成员集体出走。据知情人士透露，内讧的导火索是该艺人的家人过度干预工作室运营，导致专业人员无法正常工作。',
    content: `<p>娱乐圈又一起内讧事件引发关注。某知名艺人的工作室近日发生重大人事变动，跟随该艺人多年的经纪人和多位核心团队成员在同一时间集体离职。</p>
<p>据知情人士透露，事件的导火索是该艺人的家人（尤其是配偶和父母）近年来不断加大对工作室运营的干预力度。从剧本选择、商务谈判到日常运营，家人都要插手做决定，导致专业团队处处受制。</p>
<p>离职的经纪人向友人透露，最令人无法接受的是，家人在没有专业判断的情况下推翻团队经过多轮谈判达成的合作协议，导致多个优质项目流产。此外，家人还经常在公开场合对团队颐指气使，让团队成员在业内颜面尽失。</p>
<p>业内人士分析认为，在娱乐圈，家人干预艺人事业是常见现象，但过度干预往往会适得其反。失去了经验丰富的经纪人团队，该艺人的后续发展将面临严峻挑战。</p>`,
    category: 'mingxing',
    categoryName: '明星爆料',
    image: 'https://readdy.ai/api/search-image?query=Empty%20office%20with%20abandoned%20desks%20and%20chairs%2C%20corporate%20exodus%20theme%2C%20dramatic%20lighting%20through%20windows%2C%20professional%20documentary%20photography%20style&width=800&height=450&seq=article-16&orientation=landscape',
    author: '51黑料编辑部',
    date: '2026-07-21',
    views: 143200,
    tags: ['艺人', '工作室', '内讧', '经纪人'],
    isHot: false,
    isNew: false,
  },
  {
    id: 17,
    slug: 'wangluo-baoli-yulequan-weihai',
    title: '网络暴力再酿悲剧！某选秀选手因遭网暴退赛后确诊抑郁症，发文告别引泪目',
    excerpt: '一位参加热门选秀节目的年轻选手因在节目中表现不佳遭到大规模网络暴力，被迫退赛后确诊重度抑郁症。该选手近日在社交平台发布长文，字字泣血地讲述了自己的遭遇，引发社会对网络暴力的反思。',
    content: `<p>网络暴力的危害再次刺痛了公众的神经。一位参加热门选秀节目的年轻选手，因为在节目中的表现未达到观众预期，遭受了持续数月的大规模网络暴力攻击，最终被迫退赛。</p>
<p>该选手近日在社交平台发布了一篇长达2000字的心路历程，详细描述了自己被网暴的经历。从外貌羞辱、能力否定到人身威胁和P遗照，这些恶毒的攻击让她每天以泪洗面。在医院确诊重度抑郁症后，她不得不选择退赛并暂停所有公开活动。</p>
<p>"我曾经以为只要努力就能获得认可，但我错了。无论我做什么，评论区永远都是骂我的声音。我开始怀疑自己是不是真的那么差劲，是不是不该活在这个世界上。"这些文字令无数网友看后泪目。</p>
<p>该选手的遭遇引发了社会对网络暴力的广泛讨论。心理专家指出，网络暴力的本质是一种群体性的去个体化行为，施暴者躲在匿名面具后肆意宣泄，却对受害者的心理健康造成毁灭性的打击。</p>`,
    category: 'yulequan',
    categoryName: '娱乐圈',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20hate%20comments%20in%20a%20dark%20room%2C%20cyberbullying%20theme%2C%20emotional%20loneliness%2C%20blue%20screen%20glow%20on%20a%20sad%20face%2C%20professional%20documentary%20photography&width=800&height=450&seq=article-17&orientation=landscape',
    author: '51黑料编辑部',
    date: '2026-07-20',
    views: 167800,
    tags: ['网络暴力', '选秀', '抑郁症', '退赛'],
    isHot: false,
    isNew: false,
  },
  {
    id: 18,
    slug: 'shipinhao-jiaju-pianju',
    title: '直播带货套路揭秘：9.9元秒杀全是套路，前员工曝光直播间话术培训内幕',
    excerpt: '一位曾在知名直播带货团队工作过的前员工近日向媒体曝光，揭示了直播间那些令人眼花缭乱的"秒杀""福利"背后的营销套路。从话术培训到剧本设计，一切都是精心策划的消费陷阱。',
    content: `<p>那些让你热血沸腾的"9.9元秒杀"和"限量福利"，背后究竟有多少是真的？一位曾在知名直播带货团队工作过两年的前员工，近日向媒体全面曝光了直播间的营销套路。</p>
<p>据其介绍，所谓的"秒杀"往往只有极少量真实库存，大部分是通过技术手段制造出的"已抢光"假象。直播间的"激烈竞价"和"临时加库存"更是精心排练的剧本，主播和助播之间的一唱一和全部经过提前演练。</p>
<p>更令人震惊的是，直播团队会针对不同商品设计专门的"话术手册"。手册中详细记录了如何利用消费者的从众心理、损失厌恶和锚定效应来促进下单。例如，"仅剩XX件"的倒计时、"老板在亏钱"的苦情戏码等，都是经典套路。</p>
<p>消费者权益保护协会提醒，直播间购物时要保持理性，不要被主播营造的"紧迫感"裹挟。如遇虚假宣传或消费欺诈，应及时保留证据并向相关部门投诉举报。</p>`,
    category: 'wanghong',
    categoryName: '网红黑料',
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20a%20live%20streaming%20studio%20with%20scripts%20and%20fake%20products%2C%20consumer%20deception%20theme%2C%20revealing%20documentary%20style%2C%20professional%20photography&width=800&height=450&seq=article-18&orientation=landscape',
    author: '51黑料编辑部',
    date: '2026-07-19',
    views: 75600,
    tags: ['直播', '套路', '秒杀', '话术'],
    isHot: false,
    isNew: false,
  },
  {
    id: 19,
    slug: 'yulequan-duben-neimu',
    title: '娱乐圈赌博黑幕触目惊心！多位艺人被曝境外豪赌，欠下巨额赌债无力偿还',
    excerpt: '据知情人士向本平台提供独家线索，多位知名艺人涉嫌在境外赌场进行巨额赌博，其中有人已欠下数千万赌债无力偿还。爆料称有艺人被债主上门追债，不得不变卖房产和豪车还债。',
    content: `<p>娱乐圈的光鲜背后，隐藏着令人触目惊心的赌博黑洞。据多位知情人士向本平台提供独家线索，多名知名艺人在境外赌场长期进行巨额赌博活动。</p>
<p>据爆料，这些艺人通常选择前往澳门、新加坡或东南亚国家的赌场，每次赌资动辄数百万元。由于长期沉迷赌博，有人已欠下数千万赌债，被债主通过各种方式追讨。</p>
<p>一位接近某二线男星的知情者透露，该男星在澳门一夜之间输掉了两套房产的价值，此后不得不频繁接各种商演和小成本网剧来还债，事业一落千丈。</p>
<p>更令人担忧的是，部分艺人欠下的不仅是赌场的债，还有地下钱庄的高利贷。有艺人被债主上门威胁，甚至被限制了人身自由，处境十分艰难。</p>
<p>法律专家指出，虽然境外赌博在某些地区合法，但中国公民在境外参与赌博活动若涉及巨额资金转移，可能违反跨境资金管理规定，面临法律风险。</p>`,
    category: 'mingxing',
    categoryName: '明星爆料',
    image: 'https://readdy.ai/api/search-image?query=Casino%20chips%20and%20playing%20cards%20scattered%20on%20a%20dark%20table%20with%20dramatic%20red%20lighting%2C%20gambling%20addiction%20theme%2C%20luxurious%20but%20dark%20atmosphere%2C%20professional%20photography&width=800&height=450&seq=article-19&orientation=landscape',
    author: '51黑料编辑部',
    date: '2026-07-18',
    views: 92100,
    tags: ['赌博', '境外', '艺人', '债务'],
    isHot: false,
    isNew: false,
  },
  {
    id: 20,
    slug: 'zhubofengsha-pingtai-zhengce',
    title: '平台封杀机制内幕：主播触犯哪些红线会被永久封禁？内部审核标准曝光',
    excerpt: '一份疑似来自某头部直播平台的内部审核标准文件近日流出，详细列出了主播可能被永久封禁的各种行为和红线。从违规内容到商业违约，平台的封杀标准比外界想象的更加严格和复杂。',
    content: `<p>主播们最害怕的"永久封禁"究竟是如何触发的？一份疑似来自某头部直播平台的内部审核标准文件近日在网络上流传，揭开了平台封杀机制的神秘面纱。</p>
<p>根据文件内容，平台将违规行为分为三个等级：轻度违规（警告或短期禁播）、中度违规（长期禁播或限流）、重度违规（永久封禁）。重度违规行为包括但不限于：传播违法信息、严重违背公序良俗、多次严重违约、涉及刑事犯罪等。</p>
<p>值得注意的是，文件中还详细列出了"灰色地带"行为的标准。例如，虽然没有明确违规但引发重大负面舆情的，平台也会根据"社区影响"进行评估。这意味着主播不仅需要遵守明文规定，还要时刻注意自己的公众形象。</p>
<p>此外，文件还揭示了平台的"连带责任"机制。如果一个MCN机构旗下的多个主播频繁违规，平台可能对整个机构进行处罚，波及机构旗下所有主播。</p>
<p>业内人士指出，随着监管趋严和平台责任的增加，直播行业的合规门槛正在不断提高，对主播和机构的专业素养要求也越来越高。</p>`,
    category: 'wanghong',
    categoryName: '网红黑料',
    image: 'https://readdy.ai/api/search-image?query=Red%20ban%20hammer%20over%20a%20smartphone%20screen%20showing%20social%20media%20interface%2C%20account%20suspension%20theme%2C%20dramatic%20warning%20atmosphere%2C%20professional%20digital%20photography&width=800&height=450&seq=article-20&orientation=landscape',
    author: '51黑料编辑部',
    date: '2026-07-17',
    views: 58900,
    tags: ['封杀', '平台', '主播', '审核'],
    isHot: false,
    isNew: false,
  },
];

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find(a => a.slug === slug);
};

export const getArticlesByCategory = (slug: string): Article[] => {
  return articles.filter(a => a.category === slug);
};

export const getHotArticles = (): Article[] => {
  return articles.filter(a => a.isHot);
};

export const getLatestArticles = (limit: number = 10): Article[] => {
  return [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, limit);
};

export const getRelatedArticles = (currentSlug: string, category: string, limit: number = 4): Article[] => {
  return articles.filter(a => a.slug !== currentSlug && a.category === category).slice(0, limit);
};